import { ExternalLink } from './ExternalLink'

const isExternal = (href: string) => {
  return href.startsWith('http') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('#')
}

type Props = {
  children: React.ReactNode
  href: string
  target?: string
  notStyled?: boolean
}

export const Link = (props: Props) => {
  if (props.href === '') return props.children

  if (isExternal(props.href)) {
    return (
      <ExternalLink href={props.href} target={props.target || '_blank'} notStyled={props.notStyled}>
        {props.children}
      </ExternalLink>
    )
  } else {
    return (
      <a href={props.href} style={{ textDecoration: 'none', color: 'inherit' }}>
        {props.children}
      </a>
    )
  }
}
